import { Api } from "domain/core";
import { Indicator, IndicatorSource } from "domain/models";
import { AuthorizedService } from "./authorized-service.base";
import { SignUrlService } from "./data/signurl.service";

export class IndicatorService extends AuthorizedService {

  public createIndicator = (data: Partial<Indicator>): Promise<any> => {
    const url = `${Api.baseUrl}${Api.admin.indicators.base}`;
    return this.fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
    }).then(r => r.json());
  }

  public patchIndicator = (indicatorId: string, data: Partial<Indicator>): Promise<any> => {
    const url = `${Api.baseUrl}${Api.admin.indicators.base}/${indicatorId}`;
    return this.fetch(url, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  };

  public deleteIndicator(indicatorId: string): Promise<Response> {
    const url = `${Api.baseUrl}${Api.admin.indicators.base}/${indicatorId}`;
    return this.fetch(url, {
      method: 'DELETE',
    });
  };

  public createSource = (data: Partial<IndicatorSource>): Promise<any> => {
    const url = `${Api.baseUrl}${Api.admin.indicators.sources}`;
    return this.fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
    }).then(r => r.json());
  }

  public patchSource = (sourceId: string, data: Partial<IndicatorSource>): Promise<any> => {
    const url = `${Api.baseUrl}${Api.admin.indicators.sources}/${sourceId}`;
    return this.fetch(url, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  };

  public exportIndicators = () => {
    const url = `${Api.baseUrl}${Api.admin.indicators.base}/export`;
    return new SignUrlService().signUrl(url)
      .then(token => {
        return `${url}?token=${token}`;
      });
  };

  public deleteYear = (year: number, indicatorCode: string): Promise<Response> => {
    const url = `${Api.baseUrl}${Api.admin.indicators.base}/${indicatorCode}/by-year/${year}`;
    return this.fetch(url, {
      method: 'DELETE',
    });
  }

}

export const indicatorService = new IndicatorService();
